export const UPDATE_ROUTES = 'UPDATE_ROUTES'
export const SET_INTERVAL = 'SET_INTERVAL'
export const CLEAR_INTERVAL = 'CLEAR_INTERVAL'
